import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useBrandIdentity } from "../components/BrandRuntimeGate";

// Route-aware document title for Counter Culture · CulinexOS.
// Falls back to "CulinexOS" when a section is not explicitly mapped.
// Phase 135 · Every module label is the CULINEX brand it belongs to.
const SECTION_TITLES = [
  { match: /^\/self-order(?:\/|$)/, label: "Self Ordering Kiosk" },
  { match: /^\/order\/?$/, label: "Online Ordering" },
  { match: /^\/track(?:\/|$)/, label: "Order Tracking" },
  // CULINEX POS
  { match: /^\/pos/,             label: "CULINEX POS" },
  // CULINEX ORDER
  { match: /^\/telephone-order/, label: "CULINEX ORDER" },
  { match: /^\/order$/,          label: "CULINEX ORDER" },
  { match: /^\/orders/,          label: "CULINEX ORDER" },
  { match: /^\/coupons/,         label: "CULINEX ORDER" },
  { match: /^\/qr-campaigns/,    label: "CULINEX ORDER" },
  { match: /^\/marketplace/,     label: "CULINEX ORDER" },
  { match: /^\/delivery-command/,label: "CULINEX ORDER" },
  { match: /^\/delivery-zones/,  label: "CULINEX ORDER" },
  { match: /^\/rider/,           label: "CULINEX ORDER" },
  { match: /^\/track/,           label: "CULINEX ORDER" },
  // CULINEX FLOW
  { match: /^\/kds/,             label: "CULINEX FLOW" },
  { match: /^\/production/,      label: "CULINEX FLOW" },
  { match: /^\/prep-recipes/,    label: "CULINEX FLOW" },
  { match: /^\/prep-board/,      label: "CULINEX FLOW" },
  // CULINEX STOCK
  { match: /^\/ingredients/,     label: "CULINEX STOCK" },
  { match: /^\/stock-count/,     label: "CULINEX STOCK" },
  { match: /^\/waste/,           label: "CULINEX STOCK" },
  { match: /^\/history/,         label: "CULINEX STOCK" },
  { match: /^\/suppliers/,       label: "CULINEX STOCK" },
  { match: /^\/procurement/,     label: "CULINEX STOCK" },
  { match: /^\/master-data/,     label: "CULINEX STOCK" },
  // CULINEX COST
  { match: /^\/recipes/,         label: "CULINEX COST" },
  { match: /^\/menu/,            label: "CULINEX COST" },
  { match: /^\/simulator/,       label: "CULINEX COST" },
  { match: /^\/engineering/,     label: "CULINEX COST" },
  { match: /^\/food-trials/,     label: "CULINEX COST" },
  // CULINEX MONEY
  { match: /^\/analytics/,       label: "CULINEX MONEY" },
  { match: /^\/channel-pnl/,     label: "CULINEX MONEY" },
  { match: /^\/expenses/,        label: "CULINEX MONEY" },
  { match: /^\/closing/,         label: "CULINEX MONEY" },
  { match: /^\/approvals/,       label: "CULINEX MONEY" },
  // CULINEX SAGE
  { match: /^\/intelligence/,    label: "CULINEX SAGE" },
  { match: /^\/sage-inbox/,      label: "CULINEX SAGE" },
  { match: /^\/sage-plan/,       label: "CULINEX SAGE" },
  { match: /^\/forecast/,        label: "CULINEX SAGE" },
  { match: /^\/system-health/,   label: "CULINEX SAGE" },
  // CULINEX CONNECT
  { match: /^\/customers/,       label: "CULINEX CONNECT" },
  { match: /^\/customer-voice/,  label: "CULINEX CONNECT" },
  { match: /^\/reviews/,         label: "CULINEX CONNECT" },
  // Workspace (platform housekeeping — outside the 8 brands)
  { match: /^\/outlets/,         label: "Workspace" },
  { match: /^\/team/,            label: "Workspace" },
  { match: /^\/integrations/,    label: "Workspace" },
  { match: /^\/import/,          label: "Workspace" },
  { match: /^\/help/,            label: "Workspace" },
  { match: /^\/academy/,         label: "Workspace" },
  { match: /^\/login/,           label: "Sign In" },
  { match: /^\/register/,        label: "Sign Up" },
  { match: /^\/public\/menu/,    label: "Menu" },
];

export function resolveTitle(pathname, brandName = "Counter Culture - By Chef Sadiq") {
  const hit = SECTION_TITLES.find((row) => row.match.test(pathname));
  const section = hit ? hit.label : "CulinexOS";
  return `${brandName} · ${section}`;
}

export default function useDocumentTitle() {
  const { pathname } = useLocation();
  const { brand_key, display_name } = useBrandIdentity();
  const brandName = brand_key === "rolls_and_brew" ? "Counter Culture - By Chef Sadiq" : display_name;
  useEffect(() => {
    document.title = resolveTitle(pathname, brandName);
  }, [pathname, brandName]);
}
